import {
  AssignFieldsRequest,
  CreateTermsetRequest,
  Termset,
  TermsetAPI,
  TermsetSearchQuery,
  UpdateTermsetRequest,
} from './TermsetAPI'

export interface Farm extends Termset {
  name: string
  address?: {
    street: string
    street_2?: string
    postalCode: string
    city: string
    state: string
    countryCode: string
    country: string
  }
}

const PATHS = {
  LIST: '/termset/farms',
  ENTITY: '/termset/farms/:id',
  FIELDS: '/termset/farms/linkWithResources',
  QUERY: '/termset/farms/query',
}

export const FarmsAPI = new TermsetAPI<Farm>(PATHS)

export type CreateFarmRequest = CreateTermsetRequest<Farm>
export type UpdateFarmRequest = UpdateTermsetRequest<Farm>
export type FarmSearchQuery = TermsetSearchQuery
export type { AssignFieldsRequest }

